'use client'

import { MoonIcon, SunIcon } from '@heroicons/react/24/solid'
import { useTheme } from '@wrksz/themes/client'
import { useEffect, useState } from 'react'

export function ThemeChanger() {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  const isDark = theme === 'dark'

  return (
    <button
      type='button'
      aria-label={isDark ? 'Włącz jasny motyw' : 'Włącz ciemny motyw'}
      className='inline-flex size-11 items-center justify-center rounded-md text-contentTertiary'
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      {isDark ? <SunIcon className='size-6' /> : <MoonIcon className='size-6' />}
    </button>
  )
}
